import React, { Component } from 'react';
import '../App.css';
import TemplateListItem from '../components/TemplateListItem'
import MyFlowsListItemComponent from '../components/MyFlowsListItemComponent'
import { withRouter } from 'react-router-dom'
import { getJson } from '../helpers/RequestsHelper'
import { withTranslation } from 'react-i18next';

class SearchPage extends Component {

    state = {
        loadingTemplates: true,
        loadingWorkflows: true,
        searchText: "",
        templates: [],
        workflows: []
    }

    constructor(props) {
        super(props)
        this.onSelect = this.onSelect.bind(this)
        this.onSearchChanged = this.onSearchChanged.bind(this)
        this.fillTemplates = this.fillTemplates.bind(this)
        this.fillWorkFlows = this.fillWorkflows.bind(this)
    }

    componentDidMount() {
        const { t } = this.props;
        document.title = t("titleappname") + t("title_search")
    }

    async fillTemplates(searchText) {
        let url = process.env.REACT_APP_SERVER_BASE_URL + "/templates";
        url += "?search=" + searchText
        const items = await getJson(url);

        const sortedItems = items.sort(function (a, b) {
            //Show first the implemented
            if (a.comingsoon && !b.comingsoon) {
                return 1
            }
            if (b.comingsoon && !a.comingsoon) {
                return -1
            }

            //If both are comming soon we check the vote number
            if (a.comingsoon && b.comingsoon) {
                return b.votes - a.votes
            }

            //The rest are sorted by title 
            return a.title.localeCompare(b.title)
        });

        this.setState(({ templates: sortedItems, loading: false }));
    }

    async fillWorkflows(searchText) {
        let url = process.env.REACT_APP_SERVER_BASE_URL + "/workflows";
        url += "?search=" + searchText
        const workflows = await getJson(url);

        this.setState(({ workflows, loadingWorkflows: false }));
    }

    render() {
        return (
            this.getElementsView(this.props.element, this.props.name)
        )
    }

    onSelect(flow) {
        this.props.history.push("/workflow/template/" + flow._id);
    }

    onSearchChanged(event) {
        this.setState({ searchText: event.target.value });
        if (event.target.value.length > 3) {
            this.fillTemplates(event.target.value)//TODO: setInterval
            this.fillWorkflows(event.target.value)
        }
    }

    getElementsView() {
        // if (this.state.loading) {
        //     return <div className="spinner-border icons-list-item" role="status">
        //         <span className="sr-only">Loading...</span>
        //     </div>
        // }
        const { t } = this.props;

        let workflowsListItems = []
        this.state.workflows.forEach(workflow => {
            workflowsListItems.push(
                <MyFlowsListItemComponent key={workflow._id} data={workflow} onClick={this.onSelect} />
            )
        })

        let templatesListItems = []
        let comingsoonListItems = []
        let userTemplates = []
        this.state.templates.forEach(template => {
            if (template.user) {
                userTemplates.push(
                    <TemplateListItem template={template} key={template._id} onClick={this.onSelect} isLegacy={this.props.isLegacy} windowWidth={this.props.windowWidth} />
                )
            }
            else if (template.comingsoon) {
                comingsoonListItems.push(
                    <TemplateListItem template={template} key={template._id} onClick={this.onSelect} isLegacy={this.props.isLegacy} windowWidth={this.props.windowWidth} />
                )
            } else {
                templatesListItems.push(
                    <TemplateListItem template={template} key={template._id} onClick={this.onSelect} isLegacy={this.props.isLegacy} windowWidth={this.props.windowWidth} />
                )
            }
        })

        return (
            <div>
                {
                    this.props.isLegacy?
                        <div className="wrap-input100 validate-input w-400">
                            <input className="form-control w-400"
                                type="search"
                                name="search"
                                id="search"
                                placeholder={t("title_search_workflow")}
                                value={this.state.searchText}
                                onChange={this.onSearchChanged}
                                autoComplete="off"
                                required={true}
                            />
                            <span className="focus-input100" style={{ top: "-11px" }} data-symbol="&#xf002;"></span>
                        </div>
                    :
                        <div className="wrap-input100 validate-input" style={{width: this.props.windowWidth > 993? "400px" : this.props.isLegacy? "400px" : "100%"}}>
                            <input className="form-control"
                                style={{width: this.props.windowWidth > 993? "400px" : this.props.isLegacy? "400px" : "100%"}}
                                type="search"
                                name="search"
                                id="search"
                                placeholder={t("title_search_workflow")}
                                value={this.state.searchText}
                                onChange={this.onSearchChanged}
                                autoComplete="off"
                                required={true}
                            />
                            <span className="focus-input100" style={{ top: "-11px" }} data-symbol="&#xf002;"></span>
                        </div>
                }

                <br />
                {workflowsListItems.length !== 0 || templatesListItems.length === 0 ?
                    <div className="apps-group">
                        <p className="apps-group-title">Workflows</p>
                        {workflowsListItems.length === 0 && this.state.searchText.length > 3 ? t("warning_search_no_results") : workflowsListItems}
                    </div>
                    : ""}
                {userTemplates.length > 0 ?
                    <>
                        <br />
                        <div className="apps-group">
                            <p className="apps-group-title">My Templates</p>
                            {userTemplates}
                        </div>
                    </>
                    : ""}
                {templatesListItems.length !== 0 || workflowsListItems.length === 0 ?
                    <>
                        <br />
                        <div className="apps-group">
                            <p className="apps-group-title">Templates</p>
                            {templatesListItems.length === 0 && this.state.searchText.length > 3 ? t("warning_search_no_results") : templatesListItems}
                        </div>
                    </>
                    : ""}
                {comingsoonListItems.length !== 0 ?
                    <>
                        <br />
                        <div className="apps-group">
                            <p className="apps-group-title">Coming Soon</p>
                            {comingsoonListItems.length === 0 && this.state.searchText.length > 3 ? t("warning_search_no_results") : comingsoonListItems}
                        </div>
                    </>
                    : ""}
            </div>
        )
    }

}

export default withRouter(withTranslation()(SearchPage), SearchPage);